exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CancelButton__button___2ji2R {\n  border: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 14px;\n  font-weight: bold;\n  border-radius: 5px;\n  cursor: pointer;\n  width: 262px;\n  height: 50px; }\n  @media (max-width: 576px) {\n    .CancelButton__button___2ji2R {\n      display: block;\n      width: 100%;\n      text-align: center;\n      background-color: white;\n      margin-left: 0;\n      box-shadow: none; } }\n\n.CancelButton__button___2ji2R {\n  background-color: #f94144;\n  color: white; }\n\n.CancelButton__button___2ji2R {\n  margin-top: 30px;\n  margin-right: 10px;\n  color: #828282;\n  box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.1);\n  background-color: #ffffff !important; }\n\n@media (max-width: 768px) {\n  .CancelButton__button___2ji2R {\n    margin-inline: auto;\n    margin-top: 10px; } }\n", ""]);

// exports
exports.locals = {
	"button": "CancelButton__button___2ji2R"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/AdPromotePage/PromotionPackages/CancelButton/CancelButton.scss
// module id = 5089
// module chunks = 6